// extracted by mini-css-extract-plugin
export var modalFooter = "_rm-0";